<template>
    <div>
        <headful
            title="Caseen - Log Out"
        />
        <h2>Logging out:</h2>
        <br><br>
        <md-progress-spinner 
            :md-diameter="60" 
            :md-stroke="10" 
            md-mode="indeterminate">
        </md-progress-spinner>
    </div>
</template>

<script>
    import * as Sentry from '@sentry/browser'

    export default {
        mounted: function(){
            this.$nextTick(function () {
                this.$store.commit("setJWTToken", undefined)
                Sentry.configureScope((scope) => {
                    scope.setUser({});
                });
                window.location = "/"
            })
        }
    }
</script>
